import { Box } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Assunto from './Assunto';
import CodigoNoEmail from './CodigoNoEmail';
import CodigoVerificacao from './CodigoVerificacao';
import ConfirmarCampos from './ConfirmarCampos';
import PosicaoFila from './PosicaoFila';
import TelaNSerie from './TelaNSerie';
import LoadingScreen from './LoadingScreen';

import './NavigationScreensAnimation.css';

export default function NavigationScreens() {
  const [activeStep, setActiveStep] = useState(-1);
  const [prevStep, setPrevStep] = useState(-1);

  const [emailMask, setEmailMask] = useState('');
  const [numSerie, setNumSerie] = useState('');
  const [userData, setUserData] = useState(null);
  const [assunto, setAssunto] = useState('');

  useEffect(() => {
    const bootstrapCheckout = () => {
      const userSession = JSON.parse(localStorage.getItem('tecnozap_user_session'));
      const hasTrustedSession = Boolean(userSession?.trustedVci && userSession?.numSerie);

      if (hasTrustedSession) {
        setNumSerie(userSession.numSerie);
        setActiveStep(3);
      } else {
        setNumSerie('');
        setActiveStep(0);
      }
    };

    bootstrapCheckout();
  }, []);

  const handleToScreenCheckout = useCallback(
    (position) => {
      setPrevStep(activeStep);
      setActiveStep(position);
    },
    [activeStep]
  );

  // Define screens mapping
  const screens = {
    [-1]: <LoadingScreen />,
    0: (
      <TelaNSerie
        navigate={handleToScreenCheckout}
        setEmailMask={setEmailMask}
        setNumSerie={setNumSerie}
        initialNumSerie={numSerie}
      />
    ),
    1: <CodigoVerificacao navigate={handleToScreenCheckout} />,
    2: (
      <CodigoNoEmail
        navigate={handleToScreenCheckout}
        emailMask={emailMask}
        numeroSerie={numSerie}
      />
    ),
    3: (
      <Assunto
        navigate={handleToScreenCheckout}
        numeroSerie={numSerie}
        setUserData={setUserData}
        setAssunto={setAssunto}
        assunto={assunto}
      />
    ),
    4: (
      <ConfirmarCampos
        navigate={handleToScreenCheckout}
        userData={userData}
        assunto={assunto}
        setUserData={setUserData}
      />
    ),
    5: <PosicaoFila navigate={handleToScreenCheckout} userData={userData} />,
  };

  return (
    <TransitionGroup className="screen-container">
      {/* Create a ref for the transitioning node */}
      {(() => {
        const nodeRef = React.createRef();
        return (
          <CSSTransition
            key={activeStep}
            nodeRef={nodeRef}
            timeout={300}
            classNames={
              activeStep > prevStep
                ? 'screen-transition-forward'
                : 'screen-transition-backward'
            }
          >
            {/* Attach the ref to the DOM node */}
            <Box
              ref={nodeRef}
              className="screen-content"
              sx={{ maxHeight: { xs: 550, sm: 500, md: 500 } }}
            >
              {screens[activeStep]}
            </Box>
          </CSSTransition>
        );
      })()}
    </TransitionGroup>
  );
}
